import jsonFromDom from "./jsonFromDom";
let config = jsonFromDom(".site-config");
export default config;
